import React from "react"
import NewTitle from "../../../../quick-add/layout/page-title/form-title";
import VScroll from "../../../../../core/gd-components/scrolling/custom-v-scroll/v-scroll";
import {ReportsSelectorGroup} from "../templates/get-templates";

type Props = {
    children?       : any
    selectedGroup   : ReportsSelectorGroup
    onSelectReport  : callback
    selectedReport  : any
    searchEnabled   : boolean
    onSubmit        : callback
}

export default function ModalReportSelect_Main(props: Props) {

    const onBackClick = ()=>{

        if (!props.selectedReport) return false
        return ()=> props.onSelectReport(null)
    }

    const getTitle = ()=>{

        if(props.searchEnabled) return "Search results";

        if(!!props.selectedReport) return props.selectedReport.name;

        return props.selectedGroup?.title
    }

    return (
        <div className="new-main view">
            <NewTitle name={getTitle()}  onBackClick={onBackClick()}/>

            <VScroll className="h-100-percent">
                <div className="m-l-35 m-r-35 m-t-20 m-b-50">
                    <div className="flex-row-left-top flex-wrap flex-gap-10">

                        {props.children}

                    </div>
                </div>
            </VScroll>
        </div>
    );
}
